import {
  Backdrop as BackdropUI,
  Box,
  CircularProgress,
  Typography,
  styled,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

// Styles
const Backdrop = styled(BackdropUI)(({theme}) => ({
  zIndex: theme.zIndex.modal,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  backdropFilter: 'blur(5px)',
}));

const LoadingBackdrop = ({open}) => {
  const {t} = useTranslation();
  return (
    <Backdrop open={open}>
      <Box
        sx={{
          textAlign: 'center',
        }}
      >
        <CircularProgress />
        <Typography variant="subtitle1">
          {t('snapshotBackdrop.generating', 'Generating Snapshot...')}
        </Typography>
      </Box>
    </Backdrop>
  );
};

LoadingBackdrop.propTypes = {
  open: PropTypes.bool,
};

export default LoadingBackdrop;
